function toggleEditableFieldsPanel() {
  $('.editable-wpf-attributes').toggleClass('hidden');
}

function toggleEditableFieldStatus(event) {
  var $status = $(event.target).parent().find('.field-status');
  var status_text = $status.is('.editable') ? I18n.t('javascript.read_only') : I18n.t('javascript.editable');
  $status.toggleClass('read-only').toggleClass('editable');
  $status.text('(' + status_text + ')');
}

function listenForWpfEditableFields() {
  var editable_attributes_feature = '#feature_editable_wpf_attributes';
  var editable_fields_checkboxes = 'input[id^="feature_editable_wpf_field_"]';
  $(editable_attributes_feature).on('click', toggleEditableFieldsPanel);
  $(editable_fields_checkboxes).on('click', toggleEditableFieldStatus);
}

var Wpf = {
  listenForWpfEditableFields: listenForWpfEditableFields
};
export default Wpf;